'use client'
import * as React from 'react'
import classes from './styles.module.css'
import Image from 'next/image'
import {footerOfficeAddress, footerServiceData, subFooterLinks} from 'content/footer'
import Link from 'next/link'
import {FaLinkedin} from 'react-icons/fa'
import {FaXTwitter} from 'react-icons/fa6'
import ISOFooter from 'assets/icons/footer/ISO-footer.svg'
import addressLeftImg from 'assets/icons/footer/address-left.svg'
import addressRightImg from 'assets/icons/footer/address-right.svg'
import addressBottomImg from 'assets/icons/footer/address-bottom.svg'
import Button from 'components/button/Button'
import {useRouter} from 'next/navigation'
export default function Services() {
  const router = useRouter()
  const [text, setText] = React.useState('')
  const [error, setError] = React.useState<string | boolean>(false)
  const handleOnClick = () => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    if (emailRegex.test(text)) {
      router.push(footerServiceData.btnLink)
    } else {
      setError('Wrong Email')
    }
  }
  return (
    <div className={classes.container}>
      <div className={classes.firstRow}>
        <div className={classes.firstSection}>
          <p className={classes.inputLabel}>
            <span style={{color: 'white', fontWeight: '600'}}>
              <b>{footerServiceData.inputLabel.split('.')[0]}.</b>{' '}
            </span>
            {footerServiceData.inputLabel.split('.')[1]}.
          </p>
          <div className={classes.inputContainer}>
            <input
              placeholder="Email"
              className={classes.inputBox}
              value={text}
              onChange={e => {
                setText(e.target.value)
                setError(false)
              }}
            />
            <Button
              text={footerServiceData.btnText}
              onClick={handleOnClick}
              style={{minWidth: '90px'}}
            />
          </div>
          <div className={classes.error}>{error}</div>
        </div>
        <div className={classes.secondSection}>
          {footerServiceData.lists.map((list, idx) => (
            <div className={classes.singleList} key={`${list.title}${idx}`}>
              <p className={classes.listTitle}>{list.title}</p>
              {list.list.map((data, idx) => (
                <Link key={`${data.link}${idx}`} className={classes.singleLink} href={data.link}>
                  {data.name}
                </Link>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className={classes.addressParent}>
        <div className={classes.addressTop}>
          <Image src={addressLeftImg} alt="" className={classes.addressImage} />
          <div className={classes.addressTitle}>OUR OFFICES </div>
          <Image src={addressRightImg} alt="" className={classes.addressImage} />
        </div>

        <div className={classes.addressContainer}>
          {footerOfficeAddress.map((address, idx) => (
            <div className={classes.singleAddress} key={`${address.name}${idx}`}>
              <div className={classes.countryName}>{address.name}</div>
              <div className={classes.addressDetails}>
                {address.address.map((addressLine, idx) => (
                  <div className={classes.addressLine} key={idx}>
                    {addressLine}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <Image src={addressBottomImg} alt="" />
      </div>
      <div className={classes.subFooter}>
        <div className={classes.meta}>
          <Image src={ISOFooter} height={'75'} width={'88'} className={classes.isoImage} alt="" />
          <p className={classes.branding}>© Hybr1d Technologies Pte Ltd. , Singapore</p>
          <div className={classes.metaLinks}>
            {subFooterLinks.map((link, index) => (
              <Link key={index} href={link.href} className={classes.metaLink}>
                {link.title}
              </Link>
            ))}
          </div>
        </div>
        <div className={classes.socials}>
          <Link href="https://x.com/zap_ai" target="_blank" aria-label="twitter">
            <FaXTwitter color="#fff" size={24} />
          </Link>
          <Link
            href="https://www.linkedin.com/company/zenadmin-ai/"
            target="_blank"
            aria-label="linkedin"
          >
            <FaLinkedin color="#fff" size={24} />
          </Link>
        </div>
      </div>
    </div>
  )
}
